import {
  closingAttorneyContactCard,
  withTaxIdBesideYearBuilt,
} from '../../shared';
import type { OfferLocaleOverrides } from '../base';

export const GAOverrides: OfferLocaleOverrides = {
  locale: 'GA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            withTaxIdBesideYearBuilt(layout).concat([
              [
                {
                  name: 'property.platbook',
                  size: 50,
                },
                {
                  name: 'property.pages',
                  size: 50,
                },
              ],
            ]),
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.filter(
                    ({ from }) => from !== 'property.legalDescription',
                  ),
              },
            },
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            platbook: {
              name: 'property.platbook',
              entity: 'property',
              type: 'text',
              label: 'Deed Book',
              placeholderText: '',
            },
            pages: {
              name: 'property.pages',
              entity: 'property',
              type: 'text',
              label: 'Page',
              placeholderText: '',
            },
          },
        },
        importantDatesCard: {
          // Replaces the base layout outright — a field added to the base card
          // has to be repeated here or it never renders in GA
          layout: () => [
            [
              {
                name: 'contractDate',
                size: 33,
              },
              {
                name: 'closingDate',
                size: 33,
              },
              {
                name: 'bindingAgreementDate',
                size: 33,
              },
            ],
            [{ name: 'acceptanceDate', size: 50 }],
          ],
          fields: {
            contractDate: {
              label: 'Offer Date',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            closingDate: {
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            bindingAgreementDate: {
              name: 'bindingAgreementDate',
              entity: 'interaction',
              type: 'date',
              label: 'Binding Agreement Date',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => closingAttorneyContactCard,
      },
    },
  },
};
